import { jsBridgeEventsLib } from '../js-bridge';
import { amplitudeEventsLib } from '../amplitude-events';
import { bloomreachEventsLib } from '../bloomreach-events';
import type { PayButtonClickParams } from './types';

export const paymentPageOpen = (source: string | null) => {
  jsBridgeEventsLib.paymentPageOpened({ sourceScreen: source });
};

export const payButtonClick = (params: PayButtonClickParams) => {
  amplitudeEventsLib.paymentClick(params.promocodeNumber, params.isCharter);
  jsBridgeEventsLib.payButtonClicked(params);
  bloomreachEventsLib.payButtonClick(params);
};
